import React from 'react';
import BsButton from '../../collection/bootstrap/BsButton';
import { apiUrl } from '../../utils/api';

export default function ExcelGastos(props) {
    const descargarExcel = async () => {
        const url = apiUrl("gastos/excel");
        window.location.replace(url);
    };

    return <>
        <h2>Excel de gastos</h2>
        <p>
            Cada vez que se genera este archivo, se incluyen en él todos los gastos validados que todavía no
            han sido exportados antes.
        </p>
        <p>
            Todos los gastos incluidos en el archivo son marcados como exportados y no volverán a ser
            incluidos en ningún otro documento de Excel generado con esta herramienta.
        </p>
        <BsButton className="mt-3" onClick={descargarExcel}>Generar Excel</BsButton>
    </>;
}
